function isArray(value) {
  return typeof value === 'object' && value instanceof Array;
}

export default function AlwaysArray(values) {
  if (!isArray(values) && values !== null && values !== undefined) return [values];
  return values || [];
}
